
import { useEffect, useRef, useState } from 'react';

const defaultSteps = [
  {
    number: '1',
    title: 'Tell Us Who You Are',
    description: 'Share your background, languages, beliefs or interests, and the kinds of conversations you feel ready to hold.',
    icon: '/whatsapp.svg'
  },
  {
    number: '2',
    title: 'Create a Guide Profile',
    description: "We'll help present your story clearly so people can choose a guide whose life experience, culture, or perspective feels right.",
    icon: '/globe.svg'
  },
  {
    number: '3',
    title: 'Meet on WhatsApp',
    description: 'The Boggler makes the introduction, then you talk one-on-one about real life: questions, stories, decisions, and common ground.',
    icon: '/talk.svg'
  }
];

export default function HowItWorks({ steps: stepsProp }) {
  const steps = stepsProp || defaultSteps;
  const [visibleItems, setVisibleItems] = useState(new Array(steps.length).fill(false));
  const itemRefs = useRef([]);

  useEffect(() => {
    const observers = itemRefs.current.map((ref, index) => {
      if (!ref) return null;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry?.isIntersecting) {
            setVisibleItems(prev => {
              const newVisible = [...prev];
              newVisible[index] = true;
              return newVisible;
            });
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(ref);
      return observer;
    });
    return () => {
      observers.forEach((observer) => observer?.disconnect());
    };
  }, [steps.length]);

  return (
    <section className="py-20 px-6 bg-light-warm relative z-10">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl md:text-5xl text-dark-teal text-center mb-4">
          How Connections Begin
        </h2>
        <p className="text-xl text-secondary-text text-center mb-16 font-lato max-w-3xl mx-auto">
          The platform is simple on purpose: a thoughtful profile, a respectful introduction, and room for a private conversation.
        </p>

        <div className="grid md:grid-cols-3 gap-12 relative">
          <div className="hidden md:block absolute top-24 left-0 right-0 h-1 bg-boggler-teal opacity-20" style={{ top: '6rem' }} />

          {steps.map((step, index) => (
            <div
              key={index}
              ref={(el) => { itemRefs.current[index] = el; }}
              className={`relative text-center scroll-animate ${visibleItems[index] ? 'visible' : ''}`}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="step-container">
                <div className="relative z-10 w-24 h-24 mx-auto mb-6 bg-boggler-teal rounded-full flex items-center justify-center text-white text-4xl font-lucky shadow-boggler">
                  {step.number}
                </div>
                <div className="w-16 h-16 mx-auto mb-4">
                  <img src={step.icon} alt={step.title} className="w-full h-full object-contain" />
                </div>
              </div>
              <h3 className="text-2xl text-heading-dark mb-3">{step.title}</h3>
              <p className="text-primary-text font-lato leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
